"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var dayjs = require("dayjs");
var utc = require("dayjs/plugin/utc");
var BaseStringHandler = require("../BaseStringHandler");
dayjs.extend(utc);
var TimestampHandler = /*#__PURE__*/function (_BaseStringHandler) {
  function TimestampHandler() {
    var _this;
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, TimestampHandler);
    _this = _callSuper(this, TimestampHandler);
    (0, _defineProperty2["default"])(_this, "timezone", "utc");
    var timezone = config.timezone;
    _this.timezone = timezone !== null && timezone !== void 0 ? timezone : "utc";
    return _this;
  }
  (0, _inherits2["default"])(TimestampHandler, _BaseStringHandler);
  return (0, _createClass2["default"])(TimestampHandler, [{
    key: "validate",
    value: function validate(value) {
      return dayjs.utc(value).isValid();
    }
  }, {
    key: "format",
    value: function format(value) {
      var date = this.timezone === "utc" ? dayjs.utc(value) : dayjs(value);
      if (!date.isValid()) {
        return "";
      }
      return date.toISOString();
    }
  }]);
}(BaseStringHandler);
module.exports = TimestampHandler;